<page-content>
    <header-elitment header
            [hasSideMenu]="true">
    </header-elitment>
    <side-menu left-menu>
        <libraries-side-menu></libraries-side-menu>
    </side-menu>
    <error-401 *ngIf="is401"></error-401>
    <error-404 *ngIf="is404"></error-404>
  <module-content *ngIf="!is401 && !is404 && !isLoading" [title]="pageTitle">

      <ng-container *ngIf="null === exercise">
          <div fxLayout="row" fxLayoutAlign="center center">
              <div>
                  {{ 'Exercise_no_longer_exists' | translate }}
              </div>
          </div>
      </ng-container>

      <ng-container *ngIf="null !== exercise">
          <session-exercice-duration *ngIf="data.data.exercice.exercice.exerciceType === EXERCISE_TYPE_DURATION"
                                     [data]="data"
                                     [organization]="organization"
                                     [isEditable]="false">
          </session-exercice-duration>
          <session-exercice-repeat *ngIf="data.data.exercice.exercice.exerciceType === EXERCISE_TYPE_REPEAT"
                                   [data]="data"
                                   [sessionId]="sessionId!"
                                   [organization]="organization"
                                   [isEditable]="false">
          </session-exercice-repeat>
      </ng-container>
</module-content>

</page-content>
